import { BaseError } from "./BaseError";

export class BadRequestError extends BaseError {
  readonly status = 400;
}
